import { TextField } from '@mui/material';
import './first-login-form.scss'
import TinyLogo from 'assets/authentication/tinyLogo.svg'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import ColorButton from '../color-button/color-button';
import { StringStore } from 'StringStore';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from 'assets/authentication/amorino-logo.svg'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { AppRoutes } from '../../types/app-routes';

const validationSchema = Yup.object().shape({
  newPassword: Yup.string().required('Required'),
  newPasswordAgain: Yup.string().required('Required')
  });

interface FirstLoginFormProps {
  newPassword: string;
  newPasswordAgain: string;
}

const FirstLoginForm = () => {
  const dispatch:Function = useDispatch()
  const navigate = useNavigate()
  const isPasswordSent = useSelector((state: any) => state.auth.isPasswordSent)
    const formik = useFormik<FirstLoginFormProps>({
        initialValues: {
          newPassword: '',
          newPasswordAgain: ''
        },
        validateOnMount: true,
        validationSchema,
        onSubmit: ({ newPassword, newPasswordAgain }) => {
          // dispatch(setMyPassword(newPassword))
        }
      });
      
      useEffect(() => {
        if(isPasswordSent){
          navigate(AppRoutes.HOME)
        }
      },[isPasswordSent])

    const isSamePasswords = formik.values.newPassword === formik.values.newPasswordAgain;
    return (
      <div className="login-form">
      <div className="login-form__header">
        <img src={Logo} alt="Logo" className="login-form__logo"/>
        <div className="login-form__titles">
          <div className="login-form__title">{StringStore.authentication.firstLogin.title}</div>
          <div className="login-form__subtitle">{StringStore.authentication.firstLogin.description}</div>
        </div>
      </div>
      <div className="login-form__inputs">
      <div className="login-form__inputs__input-combo">
        <label htmlFor="newPassword" className='login-form__inputs__label'>{StringStore.authentication.firstLogin.newPassword}</label>
        <InputText id="newPassword" aria-describedby="newPassword-help" className='login-form__inputs__text-input' placeholder={StringStore.authentication.firstLogin.newPasswordPlaceholder} />
      </div>
      <div className="login-form__inputs__input-combo">
        <label htmlFor="newPasswordAgain" className='login-form__inputs__label'>{StringStore.authentication.firstLogin.confirmNewPassword}</label>
        <InputText id="newPasswordAgain" aria-describedby="newPasswordAgain-help" className='login-form__inputs__text-input' placeholder={StringStore.authentication.firstLogin.confirmNewPasswordPlaceholder} />
      </div>
        <Button label={StringStore.authentication.firstLogin.buttonLabel} raised className="login-form__inputs__button" />
       </div>
  </div>
    );
}

export default FirstLoginForm;